import Link from 'next/link';
import FavouriteButton from '#components/controls/buttons/favouriteButton/FavouriteButton';
import Mediabox from '#components/common/mediabox/Mediabox';
import s from '#components/teasers/audio-teaser/AudioTeaser.module.scss';
import { getMediabox, ImageRendererTypes } from '#config';
import { useOvermindState } from '#store/overmind';
import { FC } from 'react';
import { ITeaserRenderer } from '#components/lists/horizontal-scroll-list/HorizontalScrollList';
import { getRoute } from '#utils';
import TeaserOverline from '#components/common/teaser-meta/TeaserOverline';
import TeaserTitle from '#components/common/teaser-meta/TeaserTitle';
import EpisodeInfos from '#components/common/teaser-meta/EpisodeInfos';
import TeaserTextBox from '#components/common/teaser-meta/TeaserTextBox';
import TeaserBoxAudioIcon from '#components/common/teaser-box-audio-icon/TeaserBoxAudioIcon';
import { Media, MediaType } from '#types/generated/graphql-types';
import useTranslation from 'next-translate/useTranslation';

interface AudioTeaserProps extends ITeaserRenderer {
  teaserDataRaw: Media;
}

const AudioTeaser: FC<AudioTeaserProps> = ({ teaserDataRaw }) => {
  const { t } = useTranslation();
  const { isLoggedIn } = useOvermindState().user;

  const mediabox = getMediabox(
    ImageRendererTypes.TeaserAudio,
    teaserDataRaw?.teaserImage,
    true
  );

  const mediaType = teaserDataRaw.mediaType;

  return (
    <Link href={getRoute(teaserDataRaw, t)}>
      <article className={s.host}>
        <TeaserBoxAudioIcon curveIcon extraClass={s.audioIcon}>
          <div className={s.media}>
            <Mediabox {...mediabox} />
            {isLoggedIn && (
              <div className={s.buttonAdd}>
                <FavouriteButton item={teaserDataRaw} isSizeSmall />
              </div>
            )}
          </div>
        </TeaserBoxAudioIcon>
        <TeaserTextBox classes={`${s.podcastIcon} tw-pb-2`}>
          <a className={s.link}>
            <TeaserOverline>
              {mediaType === MediaType.Episode && (
                <>{teaserDataRaw?.season?.series?.title || ''}</>
              )}
              {mediaType === MediaType.Standalone && (
                <>
                  {teaserDataRaw.categories
                    .map((category) => category.title)
                    .join(' | ')}
                </>
              )}
            </TeaserOverline>
            <TeaserTitle size="small" lines={2}>
              <EpisodeInfos data={teaserDataRaw} hideSeasonInfo={true} />
              <span className={s.titleText}>{teaserDataRaw.title}</span>
            </TeaserTitle>
          </a>
        </TeaserTextBox>
      </article>
    </Link>
  );
};

export default AudioTeaser;
